import BaseStep from './BaseStep.js';
import {Helper} from "../../helpers/Helper.js";

export default class DefaultFields extends BaseStep{
    _init() {
        this._MultiStepForms.Hook.addAction('addWatchers', () => {
            this.#watchFields();
        });
        this._MultiStepForms.Hook.addAction('init', () => {
            this.#initPaging();
			requestAnimationFrame(() => {
				this.#syncFormFieldsToPreviews();
			});
        });

		this._MultiStepForms.Hook.addAction('nextStep', () => {
			this.#syncFormFieldsToPreviews();
		});
    }

	/**
	 * Copy values between same-name fields and update .form-field-value previews (incl. signup scf_ fields on review step).
	 */
	#syncFormFieldsToPreviews() {
		const names = [];
		const updatedPreviews = new WeakSet();
		const syncedRadioSuffixes = new Set();

		this._MultiStepForms.formWrapper.querySelectorAll('input,textarea,select')?.forEach((field) => {
			if (field.type === 'radio' && !field.checked) {
				return;
			}
			if (!field.name) {
				return;
			}
			if (!names.includes(field.name)) {
				this.#queryElementsByName(field.name).forEach((f) => {
					if (f !== field) {
						this.#setFieldValue(f, field);
					}
				});

				if (field.type === 'radio' && field.checked) {
					this.#syncRadioAcrossSteps(field, syncedRadioSuffixes);
				}

				this.#forEachPreviewForField(field, (previewEl) => {
					if (field.name !== 'campaign_goal' && !updatedPreviews.has(previewEl)) {
						this.setVisibleValue(previewEl, field);
						updatedPreviews.add(previewEl);
					}
				});

				names.push(field.name);
			}
		});
	}

	#syncRadioAcrossSteps(checkedRadio, syncedSuffixes) {
		const scfIdx = checkedRadio.name.indexOf('scf_');
		if (scfIdx === -1) {
			return;
		}
		const suffix = checkedRadio.name.slice(scfIdx);
		if (syncedSuffixes.has(suffix)) {
			return;
		}
		syncedSuffixes.add(suffix);

		const allRadios = this._MultiStepForms.formWrapper.querySelectorAll('input[type="radio"]');
		allRadios.forEach((radio) => {
			if (radio.name === checkedRadio.name || radio.name.indexOf(suffix) === -1) {
				return;
			}
			radio.checked = (radio.value === checkedRadio.value);
		});
	}

    #watchFields() {
		this.#initTextareas();
		document.querySelector("input[name='campaign_goal_other_amount'], input[name='team_campaign_goal_other_amount']")?.addEventListener("keypress", function (evt) {
			if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57)
			{
				evt.preventDefault();
			}
		});
        this._MultiStepForms.handleEvent('input,change', 'input,textarea,select', (event, field) => {
            if (field.name) {
				if (field.type === 'radio' && !field.checked) {
					return;
				}
                this.#queryElementsByName(field.name).forEach((f) => {
					this.#setFieldValue(f, field);
                });

                this.#forEachPreviewForField(field, (previewEl) => {
                    this.setVisibleValue(previewEl, field);
                });

            }
        });

		document.querySelectorAll('.edit-button').forEach((button) => {
			const fieldsContainer = button.closest('.form-group');

			if (!fieldsContainer) return;

			if (fieldsContainer.classList.contains('is-edit')) {
				if (button?.dataset?.confirm) {
					button.textContent = button.dataset.confirm;
				}
			} else {
				if (button?.dataset?.edit) {
					button.textContent = button.dataset.edit;
				}
			}
		});

	        this._MultiStepForms.handleEvent('click', '.edit-button', (event, button) => {
            event.preventDefault();

            const fieldsContainer = button.closest('.form-group');

            if (button?.dataset?.edit && button?.dataset?.confirm) {
                fieldsContainer.classList.toggle('is-edit');
            }


			const parentGroup = event.target.closest('.form-group.campaign-goal');
			if (parentGroup) {
				const fieldsContainer = parentGroup.querySelector('.fields');
				const selectField = parentGroup.querySelector('select[name="campaign_goal"]');
				if (selectField?.name === 'campaign_goal') {
					const selectedOption = selectField.options[selectField.selectedIndex];
					const goalWithoutValue = selectedOption?.dataset?.novalue;

					if (goalWithoutValue === 'on') {
						const otherWrapper = fieldsContainer?.querySelector('.campaign-goal-other-wrapper');
						const campaignGoalOtherAmountWrapper = fieldsContainer?.querySelector('.campaign_goal_other_amount_wrapper');

						if (otherWrapper) {
							otherWrapper.style.display = '';
							if (campaignGoalOtherAmountWrapper?.classList.contains('hidden')) {
								campaignGoalOtherAmountWrapper.classList.remove('hidden');
							}
						}
					}
				}
			}

			const teamParentGroup = event.target.closest('.form-group.team-goal');
			if (teamParentGroup && button?.dataset?.confirm) {
				const otherAmountInput = teamParentGroup.querySelector('[name=team_campaign_goal_other_amount]');
				const otherNameInput = teamParentGroup.querySelector('[name=team_campaign_goal_other_name]');
				const currencyLabel = teamParentGroup.querySelector('label[for="teams-4-campaign_goal_other_amount"]');
				const other_amount = otherAmountInput?.value || '';
				const other_name = (otherNameInput?.value || '').trim();
				const currencySymbol = currencyLabel?.textContent.trim() || '';
				const goalPreview = teamParentGroup.querySelector('.goal.form-field-value');
				let newText = currencySymbol + other_amount;
				if (other_name) {
					newText += ' - ' + other_name;
				}
				if (goalPreview) {
					goalPreview.textContent = newText;
					goalPreview.setAttribute('data-empty', newText);
					goalPreview.setAttribute('data-value', newText);
				}
			}

            if (fieldsContainer.classList.contains('is-edit')) {
                if (button?.dataset?.confirm) {
                    button.textContent = button.dataset.confirm;
                }
            } else {
                if (button?.dataset?.edit) {
                    button.textContent = button.dataset.edit;
                }
            }

            this._MultiStepForms.Hook.doAction('fieldEdit', fieldsContainer, button);
        })
    }

	#queryElementsByName(name) {
		if (!name) {
			return [];
		}
		return [...this._MultiStepForms.formWrapper.querySelectorAll('[name]')].filter(
			(el) => el.getAttribute('name') === name
		);
	}

	#getPreviewDataNameKeys(field) {
		const keys = new Set();
		if (!field?.name) {
			return keys;
		}
		keys.add(field.name);
		const cfMatch = field.name.match(/^cf\[(.+)\]$/);
		if (cfMatch) {
			keys.add(cfMatch[1]);
		}
		// Review preview uses data-name="scf_…" while inputs are "…-step-scf_…" (slug may include hyphens).
		const scfIdx = field.name.indexOf('scf_');
		if (scfIdx !== -1) {
			keys.add(field.name.slice(scfIdx));
		}
		if (field.name === 'team_campaign_goal_other_amount' || field.name === 'team_campaign_goal_other_name' || field.name === 'base_currency') {
			keys.add('teams_goal');
		}
		return keys;
	}

	#teamGoalOtherPreviewText() {
		const cur = this._MultiStepForms.formWrapper.querySelector('[name=base_currency]')?.value || '';
		const amount = this._MultiStepForms.formWrapper.querySelector('[name=team_campaign_goal_other_amount]')?.value || '';
		const name = (this._MultiStepForms.formWrapper.querySelector('[name=team_campaign_goal_other_name]')?.value || '').trim();
		if (!amount || !cur) {
			return '';
		}
		const formatted = Helper.currencyNumberFormatter(amount, cur, 'auto');
		return name ? `${formatted} - ${name}` : formatted;
	}

	#forEachPreviewForField(field, callback) {
		for (const key of this.#getPreviewDataNameKeys(field)) {
			this._MultiStepForms.formWrapper.querySelectorAll(`[data-name="${CSS.escape(key)}"]`).forEach(callback);
		}
	}

    setVisibleValue(value, field) {
		if (!field || field.name === 'action') return;

        if (field.type === 'file') {
            const files = field.files;

            if (files.length) {

                if (value.nodeName === 'IMG' || value.nodeName === 'VIDEO' || value.nodeName === 'AUDIO') {
                    value.src = URL.createObjectURL(files[0]);

                    value.alt = files[0].name;
                } else {
                    if (files.length > 3) {
                        value.textContent = files.length + ' ' + wp.i18n.__('Files', 'levcharity');
                    } else {
                        let filenames = [];

                        for (const file of files) {
                            filenames.push(file.name);
                        }

                        const val = filenames.join(', ');

                        value.textContent = val;
                    }
                }
            }
        } else if (field.type === 'checkbox') {
            if (!value.classList.contains('is-check')) {
                value.textContent = field.checked ? wp.i18n.__('Yes', 'levcharity') : wp.i18n.__('No', 'levcharity');
            } else {
                value.querySelector(`[data-status="${field.checked}"]`) && (value.querySelector(`[data-status="${field.checked}"]`).style.display = '');
                value.querySelector(`[data-status="${!field.checked}"]`) && (value.querySelector(`[data-status="${!field.checked}"]`).style.display = 'none');
            }
        } else if (field.type === 'url') {
            value.textContent = field.value;
            value.href = field.value;
        } else if (field.tagName === 'SELECT') {
			const opt = field.selectedIndex >= 0 ? field.options[field.selectedIndex] : null;
			const hasValue = field.value !== '' && opt && opt.value !== '';
			if (field.name === 'teams_goal' && field.value === 'other' && value.dataset?.name === 'teams_goal') {
				const t = this.#teamGoalOtherPreviewText();
				value.textContent = t || (hasValue ? opt.textContent.trim() : (value.dataset?.empty || ''));
			} else {
				value.textContent = hasValue ? opt.textContent.trim() : (value.dataset?.empty || '');
			}
        } else if (field.type === 'radio') {
			if (!field.checked) {
				return;
			}
			const item = field.closest('.levcharity_form__radio_buttons_item');
			let lbl = item?.querySelector('label');
			if (!lbl) {
				lbl = field.nextElementSibling?.tagName === 'LABEL' ? field.nextElementSibling : null;
			}
			if (!lbl && field.name) {
				const checked = this._MultiStepForms.formWrapper.querySelector(
					`input[type="radio"][name="${CSS.escape(field.name)}"]:checked`
				);
				const wrap = checked?.closest?.('.levcharity_form__radio_buttons_item');
				lbl = wrap?.querySelector('label') ?? null;
			}
			value.textContent = (lbl && lbl.textContent) ? lbl.textContent.trim() : String(field.value ?? '');
        } else if (['date', 'datetime-local', 'month', 'time', 'week'].includes(field.type)) {
            if (field.value) {
				const formats = {
					date: 'Y-m-d',
					'datetime-local': 'Y-m-d H:i',
					month: 'Y-m',
					time: 'H:i',
					week: `Y-W`
				}

				const val = Helper.date(formats[field.type], Helper.strtotime(field.value))

                value.textContent = val || '';
            } else {
                value.textContent = wp.i18n.__('Unlimited', 'levcharity');
            }
        } else {
            if (field.value === '' && field.dataset?.empty) {
                value.textContent = field.dataset?.empty || '';
            } else if (value.dataset?.name === 'teams_goal' && (field.name === 'team_campaign_goal_other_amount' || field.name === 'team_campaign_goal_other_name' || field.name === 'base_currency')) {
				const goalSel = this._MultiStepForms.formWrapper.querySelector('select[name="teams_goal"]');
				if (goalSel?.value === 'other') {
					const t = this.#teamGoalOtherPreviewText();
					const opt = goalSel.selectedIndex >= 0 ? goalSel.options[goalSel.selectedIndex] : null;
					value.textContent = t || (opt?.textContent?.trim() || (value.dataset?.empty || ''));
				} else if (goalSel) {
					this.setVisibleValue(value, goalSel);
				}
			} else if (value.dataset.name === 'campaign_goal' || value.dataset.name === 'campaign_goal_other_amount'  || value.dataset.name === 'team_campaign_goal_other_amount' || value.dataset.name === 'unlimited_goal') {

                let currency = this._MultiStepForms.formWrapper.querySelector('[name=base_currency]') || this._MultiStepForms.formWrapper.querySelector('[name=campaign_goal_other_amount]') ;
				let currency_symbol = currency?.dataset?.currencySymbol || (currency?.options && currency.options[currency?.selectedIndex]?.dataset?.symbol) || field?.dataset?.currencySymbol;

				if (field.value !== 'other' && field.name === 'campaign_goal') {

                    value.textContent = field.options[field.selectedIndex]?.value ? field.options[field.selectedIndex].textContent : (value.dataset?.empty || '');
                } else {

					const goal = this._MultiStepForms.formWrapper.querySelector('[name="campaign_goal"]')?.value === 'unlimited';
					const isUnlimited = this._MultiStepForms.formWrapper.querySelector('[name="unlimited_goal"]')?.checked || false;

					if (field.name === 'campaign_goal_other_amount' && (goal || isUnlimited)){
						value.textContent = wp.i18n.__('Unlimited Goal', 'levcharity');
					} else {
						let other_amount = this._MultiStepForms.formWrapper.querySelector('[name=campaign_goal_other_amount]')?.value || '';

						if (!other_amount) {
							other_amount = this._MultiStepForms.formWrapper.querySelector('[name=team_campaign_goal_other_amount]')?.value || ''
						}

						const customAmountName = document.querySelector('[name=campaign_goal_other_name]')?.value
						value.textContent =  (other_amount ? currency_symbol +  new Intl.NumberFormat().format(other_amount) : '') + (customAmountName ? ` - ${customAmountName}` : '')
					}
                }
            } else {
                value.textContent = field.value;
            }
        }
    }

    #setFieldValue(field, changedField) {
		if (!field || !changedField || changedField.name === 'action') return;

        if (field.name === 'search_terms') return;

        if (changedField.type === 'file') {
            field.files = changedField.files;
        } else if (changedField.type === 'checkbox') {
            const wasChecked = field.checked;
            field.checked = changedField.checked;
            field.value = changedField.value;
            if (field.checked !== wasChecked) {
                field.dispatchEvent(new Event('change', {bubbles: true}));
            }
        } else if(changedField.type === 'radio') {
			if (field.value === changedField.value) {
				field.checked = changedField.checked;
			}
        } else if (field.closest('.choices')) {
            const value = changedField.value ?? '';
            field.value = value;
            const choicesInstance = field.choices_instance || field.choicesInstance;
            if (choicesInstance && typeof choicesInstance.setChoiceByValue === 'function') {
                choicesInstance.setChoiceByValue(value);
            }
        } else {
            field.value = changedField.value;
        }

        if (field.matches('.campaign-goal')) {
            const otherWrapper = field.closest('form')?.querySelector('.campaign-goal-other-wrapper');

            if (field.value === 'other') {
				otherWrapper.style.display = '';
            } else {
				otherWrapper.style.display = 'none';
            }
        }
		else if(field.matches('[name=campaign_goal_other_name]')){
			if(field.value?.trim()){
				const previewSpan = document.querySelector('.preview [data-name=campaign_goal]')
				previewSpan.innerText = previewSpan.innerText.replace(/\- .*/, `- ${field.value}`)
			}
		}

		if(field.name === 'teams_goal' && field.value === 'other'){
			const previewWrapper = this._MultiStepForms.formWrapper.querySelector('.review-wrapper.team-select-step');

			let otherAmountInput = this._MultiStepForms.formWrapper.querySelector('[name=team_campaign_goal_other_amount]');
			let other_amount = otherAmountInput?.value || '';
			let other_name = this._MultiStepForms.formWrapper.querySelector('[name=team_campaign_goal_other_name]')?.value || '';

			let currency = this._MultiStepForms.formWrapper.querySelector('[name=base_currency]')

			let currencySymbol = '';
			if (otherAmountInput) {
				const wrapper = otherAmountInput.closest('.form-field');
				if (wrapper) {
					const label = wrapper.querySelector('label');
					currencySymbol = label?.textContent.trim() || '';
				}
			}
			if(previewWrapper){
				setTimeout(() => {
					const teams_goal = previewWrapper.querySelector('.team-goal .goal.form-field-value');
					const otherNameTrim = (other_name || '').trim();
					if (teams_goal && other_amount && currency?.value) {
						const formatted = Helper.currencyNumberFormatter(other_amount, currency.value, 'auto');
						const newText = otherNameTrim ? `${formatted} - ${otherNameTrim}` : formatted;
						teams_goal.textContent = newText;
						teams_goal.setAttribute('data-empty', newText);
						teams_goal.setAttribute('data-value', newText);
					}
				}, 100);
			}
		}

		this._MultiStepForms.Hook.doAction('changeFieldValue', field, changedField)
    }

	#initTextareas() {
		const fields = this._MultiStepForms.formWrapper.querySelectorAll('input,textarea');

		for (const field of [...fields]) {
			if(field.matches('textarea')) {
				const styles = window.getComputedStyle(field);

				const paddingTop = parseFloat(styles.paddingTop);
				const paddingBottom = parseFloat(styles.paddingBottom);
				const borderTop = parseFloat(styles.borderTopWidth);
				const borderBottom = parseFloat(styles.borderBottomWidth);
				const lineHeight = parseFloat(styles.lineHeight);

				const rows = parseFloat(field.getAttribute('rows') || (field.matches('input') ? 1 : 2));

				const minHeight = rows * lineHeight + paddingTop + paddingBottom + borderTop + borderBottom;
				const maxHeight = minHeight * 3;

				field.style.minHeight = minHeight + 'px';
				field.style.maxHeight = maxHeight + 'px';
			}

			if (!field.getAttribute('maxlength')) continue;

			let remaining = field.parentElement.querySelector('.remaining');

			field.levit_maxlength = field.getAttribute('maxlength');

			if (!remaining) {
				remaining = document.createElement('span');
				remaining.classList.add('remaining');
				if (field.nextElementSibling) {
					field?.nextElementSibling?.parentNode?.insertBefore(remaining, field.nextElementSibling);
				} else {
					field.parentElement.append(remaining);
				}
			}

			if (!remaining.textContent) {
				remaining.textContent = field.value.length + ' / ' + field.levit_maxlength;
			}


		}


		this._MultiStepForms.formWrapper.addEventListener('input', (event) => {

			if ((event.target.matches('textarea,input'))) {
				const field = event.target;

				if (!field?.levit_maxlength) return;

				if (field.value.length > field.levit_maxlength) {
					field.value = field.value.slice(0, -1);
					return false;
				}

				let remaining = field.parentElement.querySelector('.remaining');

				if (!remaining) {
					remaining = document.createElement('span');
					remaining.classList.add('remaining');
					if (field.nextElementSibling) {
						field.nextElementSibling.insertBefore(remaining);
					} else {
						field.parentElement.append(remaining);
					}
				}

				remaining.textContent = field.value.length + '/' + field.levit_maxlength;
			}
		});
	}

	#initPaging() {
			const multiStepFormWrapper = document.querySelector('.levcharity-multi-step-form-wrapper');
			if(multiStepFormWrapper){
				const gamification = multiStepFormWrapper.getAttribute('data-gamification');
				this._MultiStepForms.formSteps
					.forEach((step, index, list) => {
							if (list.length - 1 === index) {
								return;
							}

							const paging = step.querySelector('.paging')
							if (paging) {
								if(gamification){
									paging.textContent = `${index + 1}/${list.length - 1}`;
								}else{
									paging.textContent = `${index}/${list.length - 2}`;

								}
							}
						})
					}
	}
}
